import React from 'react';
import PropTypes from 'prop-types';
import './SectionHeading.scss';

const SectionHeading = props => (
  <div className={props.className}>
    <div className="section-heading">
      {props.number &&
      <div className={`heading-number ${props.numberClassName}`}>{props.number}</div>
      }
      <div className={`heading-title ${props.titleClassName}`}>{props.title}</div>
    </div>
    {props.description &&
    <p className="heading-description">{props.description}</p>
    }
    {props.children &&
    <p className="heading-description">{props.children}</p>
    }
  </div>
);

SectionHeading.propTypes = {
  number: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  numberClassName: PropTypes.string,
  children: PropTypes.node
};

export default SectionHeading;



/** WEBPACK FOOTER **
 ** ./src/components/SectionHeading/SectionHeading.js
 **/